var _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChecklist(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 33,
    viewBox: "0 0 32 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "checklist"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_26423_24161",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 32,
    height: 33
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Bounding box",
    y: 0.5,
    width: 32,
    height: 32,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_26423_24161)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "checklist_2",
    d: "M7.4013 25.8334L2.66797 21.1001L4.53464 19.2334L7.36797 22.0667L13.0346 16.4001L14.9013 18.3001L7.4013 25.8334ZM7.4013 15.1667L2.66797 10.4334L4.53464 8.56673L7.36797 11.4001L13.0346 5.7334L14.9013 7.6334L7.4013 15.1667ZM17.3346 23.1667V20.5001H29.3346V23.1667H17.3346ZM17.3346 12.5001V9.8334H29.3346V12.5001H17.3346Z",
    fill: "#E88614"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChecklist);
export default __webpack_public_path__ + "static/media/checklist.6b1c1da44815f19ffbec583ba5517090.svg";
export { ForwardRef as ReactComponent };